import React from 'react';
import BomExpandView from './Bom/BomExpandView';
import TestingExpandView from './Testing/TestingExpandView';
import MeasurementsExpandView from './Measurements/MeasurementsExpandView';
import CareLabelsExpandView from './CareLabels/CareLabelsExpandView';

function SuggestionExpandView({ subBrandAccess, index, data }) {
  return (
    <>
      {data.section === 'bom' && <BomExpandView index={index} data={data} subBrandAccess={subBrandAccess} />}
      {data.section === 'testing' && <TestingExpandView index={index} data={data} subBrandAccess={subBrandAccess} />}
      {data.section === 'measurement' && <MeasurementsExpandView index={index} data={data} subBrandAccess={subBrandAccess} />}
      {data.section === 'care-label' && <CareLabelsExpandView subBrandAccess={subBrandAccess} data={data} />}
    </>
  );
}

export default SuggestionExpandView;
